import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {
  ReportingInvoiceGridLayoutService
} from "@irb/irb-settings/settings-mmc/reporting-invoice/reporting-invoice.grid-layout.service";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {IrbMMCSettingsService} from "@irb/irb-settings/settings-mmc/irb-mmc-settings.service";
import {AppService} from "@irb/app.service";
import {IrbAppEvents} from "@irb/app.events";
import {IDropdownItem} from "@irb-common/models/dropdown.model";


@Component({
  standalone: false,
  selector: 'irb-mmc-reporting-invoice',
  templateUrl: './reporting-invoice.component.html',
  styleUrl: './reporting-invoice.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ReportingInvoiceComponent implements OnInit {
  @ViewChild("reportTypeDropDown") reportTypeDropDown: any;
  gridOptions: any;
  grid: any;
  frameworkComponents: any;
  isUiTest: boolean = false;
  gridData: any = [];
  showNewReportForm: boolean = false;
  newAsFirmId: any;
  newReportMasterAccount: any;
  newReportType: Array<IDropdownItem>;
  newRequestorUserId: any;
  listOfReportTypes: Array<any> = [];
  newRequestorUserIdRequired: boolean = false;
  newAsFirmIdRequired: boolean = false;
  newReportMasterAccountRequired: boolean = false;
  recordBeforeChange: any;
  dataLoaded: boolean = false;

  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  constructor(public gls: ReportingInvoiceGridLayoutService,
              private mmcSettingsService: IrbMMCSettingsService,
              private ctas: CalltoactionService,
              private cdr: ChangeDetectorRef,
              private as: AppService) {

    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate:
        "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No records.</span>",
      context: {componentParent: this},
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
    };
    this.listOfReportTypes = this.gls.reportingTypes;
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node: any) {
    return !node.data.isUIdeleted;
  }

  showFormForNewReport() {
    this.showNewReportForm=true;
    const timer = !this.isUiTest ? 100: 0;
    setTimeout(() => {
      this.reportTypeDropDown.set(this.listOfReportTypes);
    }, timer);
  }


  ngOnInit() {
    this.mmcSettingsService.getMMCReportRequests().subscribe({
      next: (response: any) => {
        this.gridData = response;
        // this.loadGrid();
      },
      complete: () => {
        this.dataLoaded = true;
        this.cdr.detectChanges();
      }
    });

  }

  private loadGrid() {
    if (this.grid && this.grid.api && this.gridData) {
      this.grid.api.setGridOption('rowData', this.gridData);
    }
  }

  onGridReady(params: any) {
    this.grid = params;
    this.loadGrid();
  }

  addReporting() {
    let isValid = true;
    if (!this.newAsFirmId) {
      this.newAsFirmIdRequired = true;
      isValid = false;
    }
    if (!this.newReportMasterAccount) {
      this.newReportMasterAccountRequired = true;
      isValid = false;
    }
    if (!this.newReportType || (this.newReportType && !this.newReportType.length)) {
      // this.reportTypeDropDown.inputControl.setErrors({required: true});
      this.reportTypeDropDown?.display?.nativeElement.classList.add('show-as-invalid');
      isValid = false;
    }
    if (!this.newRequestorUserId) {
      this.newRequestorUserIdRequired = true;
      isValid = false;
    }

    if (!isValid)
      return;

    this.reportTypeDropDown?.display?.nativeElement.classList.remove('show-as-invalid');
    const types = this.newReportType.map(tp => tp.value);
    const newRow: any = {
      asFirmId: Number(this.newAsFirmId),
      reportMasterAccount: this.newReportMasterAccount,
      reportTypes: types,
      requestorUserId: this.newRequestorUserId
    };
    this.mmcSettingsService.addMMCReportRequests(newRow).subscribe({
      next: (_response: any) => {
        if (_response) {
          const newRecord = _response;
          this.gridData.push(newRecord);
          this.loadGrid();
          this.resetValues();
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'success',
            summary: 'Add Report Request',
            detail: "Report request added successfully."
          });
        }

        this.newAsFirmIdRequired = false;
        this.newReportMasterAccountRequired = false;
        this.newRequestorUserIdRequired = false;
      },
      error: (_response: any) => {
        if (_response.errors && _response.errors.length) {
          let errorMsg: string = _response.errors[0].message;
          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: "ERROR",
            altMsgHTML: errorMsg
          });
        }
      }
    });
  }

  resetValues() {
    this.newAsFirmId = null;
    this.newReportMasterAccount = null;
    this.newReportType = null;
    this.newRequestorUserId = null;
  }

  onGridChange(changedData: any, params: any) {
    if (!changedData.reportTypes.length) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        dType: "WARN",
        altMsgHTML: 'Please select at least 1 report type'
      });
      params.data.reportTypes = this.recordBeforeChange.reportTypes;
      params.api.redrawRows({rowNodes: [params.node]});
      return;
    }

    const dataForUpdateCall: any = {
      asFirmId: changedData.asFirmId,
      reportMasterAccount: changedData.reportMasterAccount,
      reportTypes: changedData.reportTypes,
      requestorUserId: changedData.requestorUserId,
    }
    this.mmcSettingsService.updateMMCReportRequests(changedData.id, dataForUpdateCall).subscribe({
        next: (_response: any) => {
          if (_response) {
            const updatedData = _response;
            this.gridData.forEach((item: any) => {
              if (item.id === updatedData.id) {
                item.asFirmId = updatedData.asFirmId;
                item.reportMasterAccount = updatedData.reportMasterAccount;
                item.reportTypes = updatedData.reportTypes;
                item.requestorUserId = updatedData.requestorUserId;
                item.version = updatedData.version;
              }
            });
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'success',
              summary: 'Update Report Request',
              detail: "Report request updated successfully."
            });
          }
        },
        error: (_response: any) => {
          if (_response.errors && _response.errors.length) {
            let errorMsg: string = _response.errors[0].message;
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
              dType: "ERROR",
              altMsgHTML: errorMsg
            });
            params.data.asFirmId = this.recordBeforeChange.asFirmId;
            params.data.reportMasterAccount = this.recordBeforeChange.reportMasterAccount;
            params.data.reportTypes = this.recordBeforeChange.reportTypes;
            params.data.requestorUserId = this.recordBeforeChange.requestorUserId;
            params.api.redrawRows({rowNodes: [params.node]});
          }
        }
      });
  }

  delete(_row: any) {
    const itemToRemoveIndex = this.gridData.findIndex((x: any) => x.id === _row.id);
    this.gridData.splice(itemToRemoveIndex, 1);
    this.mmcSettingsService.deleteMMCReportRequest(_row.id).subscribe({
      next: (_response: any) => {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Delete Report Request',
          detail: "Report request deleted successfully."
        });
        this.loadGrid();
      },
      error: (_response: any) => {
        if (_response.errors && _response.errors.length) {
          let errorMsg: string = _response.errors[0].message;
          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: "ERROR",
            altMsgHTML: errorMsg
          });
        }
      }
    });
  }

  cancelDelete() {
    this.ctas.remove();
  }

  setReportTypeDropDown(searchStr: any) {
    let f: Array<IDropdownItem> = [];

    if (searchStr) {
      const r = new RegExp(searchStr, "gi");

      this.listOfReportTypes.forEach((item: IDropdownItem) => {
        if (item.name.match(r)) {
          f.push(item);
        }
      });
    } else {
      f = [].concat(this.listOfReportTypes);
    }

    this.reportTypeDropDown.set(f);
  }

  onReportTypeChange() {
    this.reportTypeDropDown?.display?.nativeElement.classList.remove('show-as-invalid');
  }

  showEmptyErrorAlert(fieldName: string, params: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: "ERROR",
      altMsgHTML: "The " + fieldName + " field cannot be empty",
      onProceed: () => {
        params.api.redrawRows({rowNodes: [params.node]});
      }
    });
  }

  rememberRecordBeforeChange(item: any) {
    this.recordBeforeChange = JSON.parse(JSON.stringify(item));
  }

}
